import React from "react";
import { Navigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

const Home = () => {
  const { role } = useAuth();

  if (!role) {
    localStorage.clear();
    return <Navigate to="/login" />;
  } else if (role === 1) {
    return <Navigate to="/admindashboard" />;
  } else {
    return <Navigate to="/supplierdashboard" />;
  }
};

export default Home;
